import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { EndpointsIntegrations } from '../integrations-flow/EndpointsIntegrations';
import { EndpointsAcademy } from './EndpointsAcademy';
import { EndpointsStandaloneCmsPartner } from './EndpointsStandaloneCmsPartner';
export const getFlowEndpointOverrides = () => {
  switch (getFlowKey()) {
    case Flow.Integrations:
      return EndpointsIntegrations;

    case Flow.Academy:
      return EndpointsAcademy;

    case Flow.StandaloneCmsPartner:
      return EndpointsStandaloneCmsPartner;

    default:
      return {};
  }
};